export default __webpack_public_path__ + "static/media/977.2a12c9f7.png";